// extracted by css-extract-rspack-plugin
module.exports =  {"modal":"RestoreGroupModal-qbO0__modal"};